var $ = require('jquery');
require('lightgallery');

var Property = function Property() {
	var $lightGalleryContainer = $('.light-gallery');
	var $moreImages = $('.more-images h3');

	if($lightGalleryContainer.length && $moreImages.length) {
		$lightGalleryContainer.lightGallery();

		$moreImages.click(function(e) {
			e.preventDefault();
			e.stopImmediatePropagation();

			$lightGalleryContainer.find('a:first').trigger('click');
		});
	}
}

module.exports = Property;